import React, { useState } from 'react';
import styled from 'styled-components';
import { Redirect, useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { useQuery, useMutation } from '@apollo/client';
import Button from '../../elements/Button';
import Input from '../../styledComponents/Input';
import { MANDANT_BY_REGISTERID } from './MandantRegisterHeadline';
import { registrationDisabledText } from '../../constants';
import { mandantSettings } from '../../queries/mandantSetting';
import { getErrorMessage } from '../../utils/errorMessages';
import { registerAtAnotherMandantMut } from '../../queries/mandant';

const ButtonRow = styled.div`
  text-align: right;

  margin-top: 10px;

  button {
    margin-left: 10px;
  }
`;

const RegisterAtAnother = ({ user, mandant, mandantSettings, registerId }) => {
  // console.log({ user, mandant, mandantSettings });

  const { addToast } = useToasts();
  const history = useHistory();
  const [registerAtAnotherMandant] = useMutation(registerAtAnotherMandantMut);
  const [mobile, setMobile] = useState(user?.mobile);
  const [mobileError, setMobileError] = useState('');

  async function handleRegister() {
    try {
      await registerAtAnotherMandant({
        variables: {
          registerId,
          mobile,
        },
      });
      // console.log(result);

      const toastText = 'Registrierung erfolgreich.';
      addToast(toastText, {
        appearance: 'success',
        autoDismiss: true,
      });
      history.push('/');
    } catch (error) {
      // console.log('====================================');
      // console.log(JSON.stringify(error, 0, 2));
      // console.log('====================================');

      if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        if (
          error.graphQLErrors[0].extensions &&
          error.graphQLErrors[0].extensions.validationErrors
        ) {
          // console.log(error.graphQLErrors[0].extensions.validationErrors);
          const { validationErrors } = error.graphQLErrors[0].extensions;
          if (
            validationErrors['mobile'] &&
            validationErrors['mobile'].length > 0
          ) {
            console.log(validationErrors['mobile'][0]);
            const firstErrorId = validationErrors['mobile'][0];
            setMobileError(getErrorMessage(firstErrorId));
          }
        }

        if (
          error.graphQLErrors[0].message &&
          error.graphQLErrors[0].message === 'already-registered'
        ) {
          const toastText =
            'Dein Account ist bereits bei dieser Organisation registriert.';
          addToast(toastText, {
            appearance: 'error',
            autoDismiss: true,
          });
          history.push('/');
        }
      }
    }
  }

  if (mandantSettings?.registrationEnabled === false) {
    return (
      <div>
        <div>{registrationDisabledText}</div>
        <br />
        <div>
          Bist du bereits bei dieser Organisation registriert? Dann klicke auf
          den OK Button, um den Einloggvorgang abzuschließen.
        </div>

        <ButtonRow>
          <Button
            onClick={() => {
              history.push('/');
            }}
            size='small'>
            OK
          </Button>
        </ButtonRow>
      </div>
    );
  }

  return (
    <div>
      Du bist derzeit eingeloggt als:
      <ul>
        <li>
          {user.firstName} {user.lastName}
        </li>
        <li>{user.email}</li>
      </ul>
      <p>
        Möchtest du Dich jetzt bei <b>{mandant.name}</b> registrieren?
      </p>
      {mandantSettings?.newUserEnterMobile === 'show' ||
      mandantSettings?.newUserEnterMobile === 'required' ? (
        <div>
          <p>
            Die folgenden zusätzlichen Angaben werden vom Anbieter angefordert:
          </p>

          {mandantSettings?.newUserEnterMobile === 'show' ||
          mandantSettings?.newUserEnterMobile === 'required' ? (
            <>
              <div>
                Mobilnummer
                {mandantSettings?.newUserEnterMobile === 'show'
                  ? ' (optional)'
                  : ' (erforderlich)'}
              </div>
              <Input
                type='text'
                name='mobile'
                placeholder='Mobilnummer'
                onChange={e => setMobile(e.target.value)}
                value={mobile}
              />

              <ValidationError error={mobileError} />
            </>
          ) : null}
        </div>
      ) : null}
      <ButtonRow>
        <Button
          onClick={() => {
            history.push('/');
          }}
          kind='danger'
          size='small'>
          Abbrechen
        </Button>

        <Button onClick={handleRegister} size='small'>
          OK
        </Button>
      </ButtonRow>
    </div>
  );
};

const ValidationErrorContainer = styled.span`
  color: red;
`;

const ValidationError = ({ error }) => {
  if (error.length === 0) {
    return null;
  }
  return <ValidationErrorContainer>{error}</ValidationErrorContainer>;
};

const RegisterAtAnotherDataWrapper = ({ mandantRegisterId, user }) => {
  const { loading, data } = useQuery(MANDANT_BY_REGISTERID, {
    variables: { mandantRegisterId },
    fetchPolicy: 'network-only',
  });
  const { data: mandantSettingsData, loading: mandantSettingsLoading } =
    useQuery(mandantSettings, {
      variables: { registerId: mandantRegisterId },
      pollInterval: 60 * 1000,
    });

  if (loading || mandantSettingsLoading) {
    return <div>Bitte warten ...</div>;
  }

  if (!data || !data.mandantByRegisterId) {
    return <Redirect to='/' />;
  }

  return (
    <RegisterAtAnother
      user={user}
      mandant={data.mandantByRegisterId}
      mandantSettings={mandantSettingsData.getMandantSettings}
      registerId={mandantRegisterId}
    />
  );
};

export default RegisterAtAnotherDataWrapper;
